import { forwardRef, type Ref, type SVGProps } from "react";
const IconPaintRollerFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.64 18.64c.697-.002 1.287.464 1.374 1.085 0 0 .992 5.653.92 7.31C21.86 28.69 20.346 30 18.5 30s-3.36-1.309-3.433-2.965c-.072-1.657.92-7.31.92-7.31.087-.621.676-1.087 1.373-1.086zm-.315 7.166a1.02 1.02 0 0 0-1.116-.226c-.383.16-.633.537-.633.956a1.03 1.03 0 0 0 1.019 1.035c.414.002.789-.25.949-.636s.073-.832-.219-1.129"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M25.999 2c1.061 0 2.079.426 2.83 1.184A4.06 4.06 0 0 1 30 6.043v2.02c0 1.072-.496 2.082-1.246 2.84s-1.77 1.072-2.83 1.071h-16c-1.061 0-1.935-.35-2.685-1.107-.75-.758-1.258-1.822-1.258-2.895h-1c-.551.002-.98.545-.981 1.102v4.043c0 .435.572.852 1.044.852l11.465-.018c1.654.005 3.018 1.338 3.018 2.928l.003.941a.25.25 0 0 1-.25.25h-1.508a.25.25 0 0 1-.25-.249l-.002-.908c-.001-.558-.496-.947-1.047-.949l-11.426.006C3.393 15.965 2.015 14.514 2 13.117V9.074c.005-1.672 1.335-3.082 2.99-3.087h1c-.001-1.072.43-2.045 1.18-2.803A3.98 3.98 0 0 1 10 2.001z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPaintRollerFilledSVG);
ForwardRef.displayName = "IconPaintRollerFilled";
export { ForwardRef as IconPaintRollerFilled };
